import React from "react";
import { Card, Col, Divider, Row, Typography, Table } from "antd";
import { apiConfig, labelConfig, staticConfig } from "../../../customer.config";
import { BOM } from "../../../../../services/definedMethod";

const { Text } = Typography;

const Preview = (props) => {
  const {
    formData,
    currencyData,
    productData,
    templateProdDetail,
    chargeTableSource,
    interestRateChartTableSource,
    customerInfo,
    previewDetails,
  } = props;
  console.log(previewDetails.maturityAmount - previewDetails.depositAmount);

  const data = {
    details: [
      {
        name: "Customer Name",
        value: customerInfo ? customerInfo.entityName : "-",
      },
      {
        name: "Product Name",
        value: formData?.details?.productId
          ? templateProdDetail?.productOptions?.find(
              (item) => item.id === formData.details.productId
            ).name
          : "-",
      },
      {
        name: "Submitted On",
        value: formData?.details?.submittedOnDate
          ? formData.details.submittedOnDate
          : "-",
      },
      {
        name: "Account Officer",
        value: formData?.details?.fieldOfficerId
          ? templateProdDetail?.fieldOfficerOptions?.find(
              (item) => item.id === formData.details.fieldOfficerId
            ).displayName
          : "-",
      },
      {
        name: labelConfig.currency,
        value: `${currencyData.name ? currencyData.name : ""}${
          currencyData.code ? ` (${currencyData.code})` : " - "
        }`,
      },
      {
        name: labelConfig.decimalPlaces,
        value: `${
          currencyData.decimalPlaces ? currencyData.decimalPlaces : "-"
        }`,
      },
      {
        name: labelConfig.currencyInMultiplesOf,
        value: `${
          currencyData.inMultiplesOf ? currencyData.inMultiplesOf : " - "
        }`,
      },
    ],

    terms: [
      {
        name: labelConfig.interestCompoundingPeriod,
        value: formData?.terms?.interestCompoundingPeriodType
          ? templateProdDetail?.interestCompoundingPeriodTypeOptions?.find(
              (item) =>
                item.id === formData?.terms?.interestCompoundingPeriodType
            ).value
          : "-",
      },
      {
        name: labelConfig.interestPostingPeriod,
        value: formData?.terms?.interestPostingPeriodType
          ? templateProdDetail?.interestPostingPeriodTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestPostingPeriodType
            ).value
          : "-",
      },
      {
        name: labelConfig.interestCalculatedUsing,
        value: formData?.terms?.interestCalculationType
          ? templateProdDetail?.interestCalculationTypeOptions?.find(
              (item) => item.id === formData?.terms?.interestCalculationType
            ).value
          : "-",
      },
      {
        name: labelConfig.daysInYear,
        value: formData?.terms?.interestCalculationDaysInYearType
          ? templateProdDetail?.interestCalculationDaysInYearTypeOptions?.find(
              (item) =>
                item.id === formData.terms.interestCalculationDaysInYearType
            ).value
          : "-",
      },
      {
        name: labelConfig.lockInPeriod,
        value: `${
          formData?.terms?.lockinPeriodFrequency
            ? formData?.terms?.lockinPeriodFrequency
            : ""
        } ${
          formData?.terms?.lockinPeriodFrequency
            ? templateProdDetail?.lockinPeriodFrequencyTypeOptions?.find(
                (item) => item.id === formData.terms.lockinPeriodFrequencyType
              ).value
            : " - "
        }`,
      },
      {
        name: labelConfig.depositAmount,
        value: formData?.terms?.depositAmount
          ? Number(formData?.terms?.depositAmount).toLocaleString()
          : "-",
      },
      {
        name: labelConfig.depositPeriod,
        value: `${
          formData?.terms?.depositPeriod ? formData?.terms?.depositPeriod : ""
        } ${
          formData?.terms?.depositPeriod
            ? templateProdDetail?.periodFrequencyTypeOptions?.find(
                (item) => item.id === formData.terms.depositPeriodFrequencyId
              ).value
            : " - "
        }`,
      },
      {
        name: labelConfig.maturityDate,
        value: previewDetails?.maturityDate
          ? `${BOM.FormatArrayDate(
              previewDetails?.maturityDate
            )} (${BOM.GetDayOfWeek(
              BOM.FormatArrayDate(previewDetails.maturityDate)
            )})`
          : "-",
      },
      {
        name: labelConfig.maturityAmount,
        value: previewDetails?.maturityAmount
          ? previewDetails?.maturityAmount?.toLocaleString()
          : "-",
      },
      {
        name: labelConfig.interestAmount,
        value:
          previewDetails?.maturityAmount && previewDetails?.depositAmount
            ? (
                previewDetails.maturityAmount - previewDetails.depositAmount
              ).toLocaleString()
            : "-",
      },
      {
        name: labelConfig.withholdingTaxRate,
        value: previewDetails?.withholdingTaxRate
          ? previewDetails.withholdingTaxRate.toLocaleString()
          : "-",
      },
      {
        name: labelConfig.withholdingTaxAmount,
        value: previewDetails?.withholdingAmount
          ? previewDetails?.withholdingAmount.toLocaleString()
          : "-",
      },
    ],
    settings: [
      {
        name: labelConfig.minimumDepositTerm,
        value: formData?.settings?.minDepositTerm
          ? formData?.settings?.minDepositTerm
          : "-",
      },
      {
        name: labelConfig.thereAferTerms,
        value: formData?.settings?.inMultiplesOfDepositTerm
          ? formData?.settings?.inMultiplesOfDepositTerm
          : "-",
      },
      {
        name: labelConfig.maximumDepositTerm,
        value: formData?.settings?.maxDepositTerm
          ? formData?.settings?.maxDepositTerm
          : "-",
      },
      {
        name: labelConfig.transferInterestToLinkedSavingsAccount,
        value: formData?.settings?.transferInterestToSavings ? "True" : "False",
      },
      {
        name: labelConfig.linkAccount,
        value: formData?.settings?.linkAccountId
          ? templateProdDetail?.savingsAccounts?.find(
              (item) => item.id === formData?.settings?.linkAccountId
            ).accountNo
          : "-",
      },
      {
        name: labelConfig.maturityInstruction,
        value: formData?.settings?.maturityInstructionId
          ? templateProdDetail?.maturityInstructionOptions?.find(
              (item) => item.id === formData?.settings?.maturityInstructionId
            ).value
          : "-",
      },
      {
        name: labelConfig.transferToAccount,
        value: formData?.settings?.transferToSavingsId
          ? templateProdDetail?.savingsAccounts?.find(
              (item) => item.id === formData?.settings?.transferToSavingsId
            ).accountNo
          : "-",
      },
      {
        name: labelConfig.isWithholdTax,
        value: formData?.settings?.withHoldTax ? "True" : "False",
      },
      {
        name: labelConfig.taxGroup,
        value: formData?.settings?.taxGroup ? formData.settings.taxGroup : "-",
      },
    ],
  };

  const columns = [
    [
      {
        title: "Period Type",
        dataIndex: "periodType",
      },
      {
        title: "Period From / To",
        dataIndex: "fromPeriodTo",
      },
      {
        title: "Amount Range",
        dataIndex: "amountRange",
      },
      {
        title: "Interest",
        dataIndex: "interest",
      },
    ],
    [
      {
        key: " 1",
        title: "Name",
        dataIndex: "name",
      },
      {
        key: " 2",
        title: "Type",
        dataIndex: "type",
      },
      {
        key: " 3",
        title: "Amount",
        dataIndex: "amount",
      },
      {
        key: " 4",
        title: "Collected On",
        dataIndex: "collectedOn",
      },
      {
        key: " 5",
        title: "Date",
        dataIndex: "feeOnMonthDay",
      },
      {
        key: "6",
        title: "Repayments Every",
        dataIndex: "collectedOn",
      },
    ],
  ];

  return (
    <Card
      style={{
        marginBottom: "2%",
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
      }}
    >
      {/* DETAILS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Details"}
        </Divider>
        {data.details.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* TERMS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Terms"}
        </Divider>
        {data.terms.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* SETTINGS FORM  */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Settings"}
        </Divider>
        {data.settings.map((detail, index) => {
          const { name, value } = detail;

          return (
            <div
              style={{
                border: "2px solid #F5F5F5",
                borderRadius: 15,
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomColor: "#E2E2E2",
              }}
              key={index}
            >
              <Row>
                <Col
                  span={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    padding: 10,
                    borderRadius: 15,
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    borderBottomLeftRadius: 0,
                  }}
                >
                  <Text strong>{name}</Text>
                </Col>
                <Col
                  span={12}
                  style={{
                    padding: 10,
                  }}
                >
                  <Text className="of-bold-disable-input">{value}</Text>
                </Col>
              </Row>
            </div>
          );
        })}
      </div>

      {/* INTEREST-CHART-RATE FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Interest Rate Chart"}
        </Divider>
        {formData?.interestRateChart.isManualInterestEntry ? (
          <div
            style={{
              border: "2px solid #F5F5F5",
              borderRadius: 15,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              borderBottomColor: "#E2E2E2",
            }}
            key="interestRate"
          >
            <Row>
              <Col
                span={12}
                style={{
                  backgroundColor: "#F5F5F5",
                  padding: 10,
                  borderRadius: 15,
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  borderBottomLeftRadius: 0,
                }}
              >
                <Text strong>Interest Rate</Text>
              </Col>
              <Col
                span={12}
                style={{
                  padding: 10,
                }}
              >
                <Text className="of-bold-disable-input">
                  {formData?.interestRateChart.nominalAnnualInterestRate}
                </Text>
              </Col>
            </Row>
          </div>
        ) : (
          <Table
            pagination={false}
            columns={columns[0]}
            dataSource={interestRateChartTableSource}
          />
        )}
      </div>

      {/* CHARGES FORM */}
      <div
        style={{
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          marginBottom: 25,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          {"Charges"}
        </Divider>
        <Table
          pagination={false}
          columns={columns[1]}
          dataSource={chargeTableSource}
        />
      </div>
    </Card>
  );
};

export default Preview;
